<template>
  <div ref="pagination" :class="{ 'hidden': hidden }" class="pagination-container">
    <el-pagination :background="background" :current-page.sync="currentPage" :page-size.sync="pageSize" :layout="layout"
      :page-sizes="pageSizes" :pager-count="pagerCount" :total="total" v-bind="$attrs" @size-change="handleSizeChange"
      @current-change="handleCurrentChange" />
  </div>
</template>

<script>
export default {
  name: "Pagination",
  props: {
    total: {
      required: true,
      type: Number
    },
    page: {
      type: Number,
      default: 1
    },
    limit: {
      type: Number,
      default: 20
    },
    pageSizes: {
      type: Array,
      default() {
        return [10, 20, 30, 50]
      }
    },
    // 移动端页码按钮的数量端默认值5
    pagerCount: {
      type: Number,
      default: document.body.clientWidth < 992 ? 5 : 7
    },
    layout: {
      type: String,
      default: "total, sizes, prev, pager, next, jumper"
    },
    background: {
      type: Boolean,
      default: true
    },
    hidden: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
    }
  },
  computed: {
    currentPage: {
      get() {
        return this.page
      },
      set(val) {
        this.$emit("update:page", val)
      }
    },
    pageSize: {
      get() {
        return this.limit
      },
      set(val) {
        this.$emit("update:limit", val)
      }
    }
  },
  methods: {
    handleSizeChange(val) {
      if (this.currentPage * val > this.total) {
        this.currentPage = 1
      }
      this.$emit("pagination", { page: this.currentPage, limit: val, type: "sizeChange" })
    },
    handleCurrentChange(val) {
      this.$emit("pagination", { page: val, limit: this.pageSize, type: "pageChange" })
      // 实现点击分页后 内容回到顶部
      this.$nextTick(() => {  
        // 原先采用获取表格 id 的方式  但是存在 一个页面多个表格的情况 就会有bug  因此改成从本分页组件 获取前一个兄弟元素
        const el = this.$refs.pagination
        const previousSibling = el.previousElementSibling // 获取前一个兄弟元素 一般分页组件都是在表格组件下一个

        const tableWrapper = previousSibling.querySelector(".el-table__body-wrapper")
        if (tableWrapper) {
          tableWrapper.scrollTo({ top: 0, behavior: "smooth" }) // 平滑滚动到顶部
        }
      })
    }
  }
}
</script>

<style scoped>
.pagination-container {
  background: #fff;
  padding: 0 16px;
  margin-top: 12px;
}

.pagination-container.hidden {
  display: none;
}
</style>
